export default __webpack_public_path__ + "06fe8fcba6eb61d197382a373961ad60.svg";